// import { Bot, IBot } from "../bot";
import { IRequestToPay, IRequestToPayData } from ".";

export class RequestToPay implements IRequestToPay {
    readonly id?: string;
    orderID?: string | undefined;
    expirationTime?: number | undefined;
    saleID?: string | undefined;
    customerID?: string | undefined;

    constructor(data: any) {
        if (data.id) {
            this.id = data.id;
        }

        this.orderID = data.orderID;
        this.expirationTime = data.expirationTime;
        this.saleID = data.saleID;
        this.customerID = data.customerID;
    }

    validate(): boolean {
        if ([null, undefined, ""].indexOf(this.id) >= 0) {
            return false;
        }
        return true;
    }

    data(): IRequestToPayData {
        return Object.assign({}, this);
    }
}
